module.exports = __webpack_public_path__ + "static/img/mock_bg.2f11d0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-template/mock_bg.png
// module id = E47t
// module chunks = 216